module.exports = __webpack_public_path__ + "static/banner_client-084e6957f28207c7711c8504e21575f9.png";